export default {
    i18n: {
        "Volume": "Volume",
        "Device Name": "Device Name",
        "Date Time": "Date Time",
        "name": "name",
        "Fingerprint": "Fingerprint",
        "Device Information": "Device Information",
        "handset": "Handset",
        "Http": "Http",
        "timezone": "timezone",
        "Are you sure you want to delete this device?": "Are you sure you want to delete this device?",
        "Attendance Point Name": "Attendance Point Name",
        "Mac": "Mac",
        "confirmToDeleteIt?": "Confirm to delete it?",
        "captureLogs": "Capture Logs",
        "Doors": "Doors",
        "All Doors": "All Doors",
        "Lock List": "Lock List",
        "Link Device Relay": "Link Device Relay",
        "Added Successfully!": "Added Successfully!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.",
        "Adding...": "Adding...",
        "Please try again 24 hours later.": "Please try again 24 hours later.",
        "Action": "Action",
        "Owner": "Owner",
        "Failed": "Failed",
        "Timeout": "Timeout",
        "Response": "Response",
        "caller": "Caller",
        "receiver": "Receiver",
        "doorLogs": "Door Logs",
        "UID": "UID",
        "Call Type": "Call Type",
        "Device List": "Device List",
        "Time": "Time",
        "Company": "Company",
        "Property Managers": "Property Managers",
        "Current Version": "Current Version",
        "indoorMonitor": "Indoor Monitor",
        "guardPhone": "Guard Phone",
        "Success": "Success",
        "URL": "URL",
        "Please select a device.": "Please select a device.",
        "Password is too weak.": "Password is too weak.",
        "Company is required.": "Company is required.",
        "Your account is not activated, please contact your service provider.": "Your account is not activated, please contact your service provider.",
        "Language": "Language",
        "Please set at least one access type.": "Please set at least one access type.",
        "Please contact your service provider to activate this advanced feature.": "Please contact your service provider to activate this advanced feature.",
        "Community name": "Community name",
        "Please enable PM App first.": "Please enable PM App first.",
        "Username": "Username",
        "Change Log": "Change Log",
        "Assign": "Assign",
        "Floor": "Floor",
        "Link Device": "Link Device",
        "Accessible Floors": "Accessible Floors",
        "Upgrade": "Upgrade",
        "Function": "Function",
        "callDuration": "Call Duration",
        "No": "No",
        "Verification Code": "Verification Code",
        "Expiration Time": "Expiration Time",
        "PIN": "PIN",
        "Building": "Building",
        "ID": "ID",
        "Name": "Name",
        "activities": "Activities",
        "Obtain": "Obtain",
        "call": "Call",
        "Group Call": "Group Call",
        "Delete": "Delete",
        "Yes": "Yes",
        "Door Release PIN": "Door Release PIN",
        "Email": "Email",
        "Mobile Number doesn\'t exist.": "Mobile Number doesn\'t exist.",
        "Tips": "Tips",
        "Password": "Password",
        "The end time cannot be earlier than the start time.": "The end time cannot be earlier than the start time.",
        "File format error.": "File format error.",
        "motionDetection": "Motion Detection",
        "You are trying too often, please try again in 5 minutes": "You are trying too often, please try again in 5 minutes",
        "User name too long.": "User name too long.",
        "This MAC address is redirected on RPS.": "This MAC address is redirected on RPS.",
        "No Answer": "No Answer",
        "failedToUnlock": "Failed to unlock",
        "visitor": "visitor",
        "yesterday": "Yesterday",
        "Too large data! Please first export the data before %s first,thanks.": "Too large data! Please first export the data before %s first,thanks.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "Please check if there is any unpaid orders, if not, please contact your service provider.",
        "open": "Open",
        "The PersonalAccount is not active.": "The PersonalAccount is not active.",
        "You cannot link an account that already link other accounts.": "You cannot link an account that already link other accounts.",
        "You cannot link multiple property manager accounts under the same installer account.": "You cannot link multiple property manager accounts under the same installer account.",
        "You cannot link to the currently logged in account.": "You cannot link to the currently logged in account.",
        "nfc": "NFC",
        "Delete Device": "Delete Device",
        "date": "Date",
        "Device deleted successfully": "Device deleted successfully",
        "Failed to delete device": "Failed to delete device",
        "Are you sure you want to cancel?": "Are you sure you want to cancel?",
        "Unlimited": "Unlimited",
        "Password Incorrect.": "Password Incorrect.",
        "deliverySystemVerification": "Delivery System Verification",
        "APT": "APT",
        "callHistory": "Call History",
        "Upgrading...": "Upgrading...",
        "amenityReservation": "Amenity Reservation",
        "idAccess": "ID Access",
        "exitButton": "Exit Button",
        "Please select at least one item.": "Please select at least one item.",
        "The ID can contain only digits and letters, up to 32 characters.": "The ID can contain only digits and letters, up to 32 characters.",
        "The PIN is not available.": "The PIN is not available.",
        "Change WiFi": "Change WiFi",
        "day": "day",
        "minutes": "minutes",
        "unlock": "Unlock",
        "Address": "Address",
        "Card": "Card",
        "MAC": "MAC",
        "Access Denied.": "Access Denied.",
        "User": "User",
        "close": "Close",
        "Face": "Face",
        "Back": "Back",
        "lock": "Lock",
        "Code": "Code",
        "Group": "Group",
        "Model": "Model",
        "None": "None",
        "RF Card": "RF Card",
        "Phone number": "Phone number",
        "Invalid {0}.": "Invalid {0}.",
        "{0} already exists.": "{0} already exists.",
        "Operation failed!": "Operation failed!",
        "Failed to get data.": "Failed to get data.",
        "You do not have the necessary permissions to perform this operation.": "You do not have the necessary permissions to perform this operation.",
        "You can only import one template at a time in the current site.": "You can only import one template at a time in the current site.",
        "Delivery name": "Delivery name",
        "MAC address not in the MAC library.": "MAC address not in the MAC library.",
        "Please delete devices under this building.": "Please delete devices under this building.",
        "The start time cannot be later than the end time.": "The start time cannot be later than the end time.",
        "emergency action type": "emergency action type",
        "Only 1000 data items can be imported at a time.": "Only 1000 data items can be imported at a time.",
        "The password is too short.": "The password is too short.",
        "The data has been updated. Please refresh the page and try again.": "The data has been updated. Please refresh the page and try again.",
        "AutoP length must be less 2048 bytes.": "AutoP length must be less 2048 bytes.",
        "File Check Failed": "File Check Failed",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "Administrator account login has expired. Please contact your service provider.",
        "iqPinVerificationFailed": "IQ PIN verification failed.",
        "accountBlacklisted": "Account blacklisted.",
        "outsideAuthorizedTime": "Outside authorized time.",
        "network group": "network group",
        "Company name": "Company name",
        "Group name": "Group name",
        "relay": "relay",
        "motionTime": "motionTime",
        "motionType": "motionType",
        "postalCode": "postalCode",
        "floor format": "floor format",
        "mobilePhone": "mobilePhone",
        "time format": "time format",
        "security relay": "security relay",
        "Param": "Param",
        "Offline Code": "Offline Code",
        "Add akubela Smart Locks": "Add akubela Smart Locks",
        "Module Version": "Module Version",
        "Lock Body Version": "Lock Body Version",
        "Available Version": "Available Version",
        "Please wake up the lock screen and then upgrade.": "Please wake up the lock screen and then upgrade.",
        "This process will take some time, please be patient.": "This process will take some time, please be patient.",
        "Please confirm that the WiFi network is functioning properly.": "Please confirm that the WiFi network is functioning properly.",
        "Please wake up the lock screen.": "Please wake up the lock screen.",
        "This lock has already been added to another apartment.": "This lock has already been added to another apartment.",
        "This lock has already been added to the apartment.": "This lock has already been added to the apartment.",
        "Pin Code": "Pin Code",
        "Too many failed attempts, please try again in a few minutes.": "Too many failed attempts, please try again in a few minutes.",
        "Login Account": "Login Account",
        "Same account cannot login in different ins.": "Same account cannot login in different ins.",
        "Lock Name": "Lock Name",
        "Smart Locks": "Smart Locks",
        "Add Smart Lock": "Add Smart Lock",
        "The selected duration cannot be more than one year.": "The selected duration cannot be more than one year.",
        "The end time of the break time cannot be later than the end work time.": "The end time of the break time cannot be later than the end work time.",
        "The start time of the break time cannot be earlier than the start work time.": "The start time of the break time cannot be earlier than the start work time.",
        "The end time of the valid check time cannot be earlier than the end work time.": "The end time of the valid check time cannot be earlier than the end work time.",
        "The start time of the valid check time cannot be later than the start work time.": "The start time of the valid check time cannot be later than the start work time.",
        "Deleting failed. The timetable is used by a shift.": "Deleting failed. The timetable is used by a shift.",
        "Deleting failed. The shift is in use.": "Deleting failed. The shift is in use.",
        "Deleting failed. The leave type is in use.": "Deleting failed. The leave type is in use.",
        "Valid time conflicts with an existing schedule.": "Valid time conflicts with an existing schedule.",
        "The timing for multiple schedules must not coincide.": "The timing for multiple schedules must not coincide.",
        "Attendance Log": "Attendance Log",
        "Added Failed!": "Added Failed!",
        "Setting WiFi": "Setting WiFi",
        "License Plate": "License Plate",
        "key": "Key",
        "IQ Offline.": "IQ Offline.",
        "{0}Unlock": "{0} Unlock",
        "automatically": "Automatically",
        "manually": "Manually",
        "Video Storage": "Video Storage",
        "Device(s) for Video Storage": "Device(s) for Video Storage",
        "The amount of exported data is too large. Please export it in batches.": "The amount of exported data is too large. Please export it in batches.",
        "Auto-record video when door unlocks": "Auto-record video when door unlocks",
        "Auto-record video during calls": "Auto-record video during calls",
        "Manual video recording in monitoring": "Manual video recording in monitoring",
        "Saved for 30days/60days/90days": "Saved for 30days/60days/90days",
        "To subscribe, please contact your provider for activation.": "To subscribe, please contact your provider for activation.",
        "Saved for {0}days": "Saved for {0}days",
        "Subscribed Plan": "Subscribed Plan",
        "Supported Devices: {0}": "Supported Devices: {0}",
        "{0}Lock": "{0} Lock",
        "Video Saving": "Video Saving",
        "Download Completed!": "Download Completed!",
        "Fail to download.": "Fail to download.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.",
        "No log to be exported.": "No log to be exported.",
        "capture&Video": "Capture & Video",
        "packageDetection": "Package Detection",
        "Time format is invalid.": "Time format is invalid.",
        "No permission to export logs of this type.": "No permission to export logs of this type.",
        "Project type is invalid.": "Project type is invalid.",
        "Salto Account Blocked.": "Salto Account Blocked.",
        "Remote open not in access group.": "Remote open not in access group.",
        "SIP Account required.": "SIP Account required.",
        "The PIN must be {0} digits.": "The PIN must be {0} digits.",
        "gatewayConnectionUnavailable": "Gateway Connection Unavailable.",
        "Invalid Username or Password": "Invalid Username or Password",
        "Account already linked to another user.": "Account already linked to another user.",
        "The account has been added by another user.": "The account has been added by another user.",
        "Failed to add. This user already has 5 license plates.": "Failed to add. This user already has 5 license plates.",
        "Please at least select a door.": "Please at least select a door.",
        "UHF Card": "UHF Card",
        "personnel": "personnel",
        "Parking Lot Name": "Parking Lot Name",
        "Controlled Relay": "Controlled Relay",
        "No Permission": "No Permission",
        "Please ensure that all doors in the project are activated at the same time.": "Please ensure that all doors in the project are activated at the same time.",
        "gatewayBusy": "Gateway busy",
        "Please set the perimeter door group first.": "Please set the perimeter door group first.",
        "Please ensure that all doors in the project are renewed at the same time.": "Please ensure that all doors in the project are renewed at the same time.",
        "When lockdown is on, the controlled relay cannot be modified.": "When lockdown is on, the controlled relay cannot be modified.",
        "DetectionLogs": "Detection Logs",
        "packageIn": "Package In",
        "packageOut": "Package Out",
        "View Progress": "View Progress",
        "Check if the WiFi is operating on the 2.4GHz band.": "Check if the WiFi is operating on the 2.4GHz band.",
        "Verify that the WiFi password is correct.": "Verify that the WiFi password is correct.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "Ensure that you are connected to the correct device hotspot during the hotspot configuration.",
        "Offline Code Unlock": "Offline Code Unlock",
        "Salto Token Expired.": "Salto Token Expired.",
        "Lock Offline": "Lock Offline",
        "identity information! Please login again": "identity information! Please login again",
        "Email is required.": "Email is required.",
        "Mobile number is required.": "Mobile number is required.",
        "You can\'t make payments for offices in different time zones.": "You can\'t make payments for offices in different time zones.",
        "The current scheduling staff exceeds 200 people.": "The current scheduling staff exceeds 200 people.",
        "param": "param",
        "Invalid UserName or Password": "Invalid UserName or Password",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "Your Salto KS account does not have permission to modify the lock\'s name.",
        "Owner is required.": "Owner is required.",
        "Office is required.": "Office is required.",
        "PIN or RF Card is required.": "PIN or RF Card is required.",
        "RF card": "RF card",
        "Personnel is required.": "Personnel is required.",
        "email address": "email address",
        "mobile number": "mobile number",
        "The length must be less than 32 characters.": "The length must be less than 32 characters.",
        "The length must be less than 256 characters.": "The length must be less than 256 characters.",
        "Access Group is required.": "Access Group is required.",
        "Device is required.": "Device is required.",
        "Admin is required.": "Admin is required.",
        "Mobile number": "Mobile number",
        "schedules": "schedules",
        "Timetable name": "Timetable name",
        "Shift name": "Shift name",
        "Leave type": "Leave type",
        "recheck in time": "recheck in time",
        "recheck out time": "recheck out time",
        "The building name": "The building name",
        "Building is required.": "Building is required.",
        "selection, The same reader cannot be set for both entry and exit": "selection, The same reader cannot be set for both entry and exit",
        "Door number": "Door number",
        "door input cannot be selection duplicated.": "door input cannot be selection duplicated.",
        "Group is required.": "Group is required.",
        "Title can contain up to 32 characters.": "Title can contain up to 32 characters.",
        "Content can contain up to 1024 characters.": "Content can contain up to 1024 characters.",
        "Content can contain up to 64 characters.": "Content can contain up to 64 characters.",
        "Report is required.": "Report is required.",
        "ID is required.": "ID is required.",
        "The office does not exist.": "The office does not exist.",
        "Office name": "Office name",
        "The Temp Key does not exist.": "The Temp Key does not exist.",
        "autolock time": "autolock time",
        "The User does not exist.": "The User does not exist.",
        "The Installer does not exist.": "The Installer does not exist.",
        "The Project does not exist.": "The Project does not exist.",
        "The Distributor does not exist.": "The Distributor does not exist.",
        "The Community Device does not exist.": "The Community Device does not exist.",
        "The Property Manager does not exist.": "The Property Manager does not exist.",
        "The Sub Distributor does not exist.": "The Sub Distributor does not exist.",
        "The Single Slave does not exist.": "The Single Slave does not exist.",
        "The Property Manager EndUser does not exist.": "The Property Manager EndUser does not exist.",
        "The Family Member does not exist.": "The Family Member does not exist.",
        "Set Failed!": "Set Failed!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.",
        "This Email doesn\'t exist.": "This Email doesn\'t exist.",
        "detection type": "detection type",
        "Device UUID": "Device UUID",
        "smart lock device": "smart lock device",
        "You are trying too often, please try again in 5 minutes.": "You are trying too often, please try again in 5 minutes.",
        "You can only import one file at a time. Please wait for the current import to finish.": "You can only import one file at a time. Please wait for the current import to finish.",
        "NVR Name": "NVR Name",
        "NVR Address": "NVR Address",
        "Stay Alarm": "Stay Alarm",
        "Happended On": "Happended On",
        "Edit Milesight NVR": "Edit Milesight NVR",
        "Add Milesight NVR": "Add Milesight NVR",
        "Auto-record video on motion detection, package detection": "Auto-record video on motion detection, package detection",
        "A 7-day free trial is included with your subscription.": "A 7-day free trial is included with your subscription.",
        "For service renewal, please reach out to your provider.": "For service renewal, please reach out to your provider.",
        "Allow the Property Manager to view recorded videos": "Allow the Property Manager to view recorded videos",
        "Please ensure the WiFi network is working properly.": "Please ensure the WiFi network is working properly.",
        "Edit akubela Smart Locks": "Edit akubela Smart Locks",
        "Upgraded Successfully!": "Upgraded Successfully!",
        "Upgraded Failed!": "Upgraded Failed!",
        "Editing...": "Editing...",
        "Edited successfully!": "Edited successfully!",
        "Edited Failed!": "Edited Failed!",
        "Downloading video...": "Downloading video...",
        "All Locks": "All Locks",
        "Select Locks": "Select Locks",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.",
        "Please at least select a door or a lock.": "Please at least select a door or a lock.",
        "This lock has already been added to your apartment.": "This lock has already been added to your apartment.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "This lock has already been added to another apartment, please contact your service provider for assistance.",
        "LockBody Version": "LockBody Version",
        "Two-factor Authentication": "Two-factor Authentication",
        "Monitoring Scope": "Monitoring Scope",
        "Stay Duration": "Stay Duration",
        "Volume Settings": "Volume Settings",
        "get card list for lock error": "get card list for lock error",
        "get card list parse fail": "get card list parse fail",
        "get pin list for lock error": "get pin list for lock error",
        "get pin list parse fail": "get pin list parse fail",
        "fingerprint code must be less than 2048 characters or empty.": "fingerprint code must be less than 2048 characters or empty.",
        "Personnel not in office.": "Personnel not in office.",
        "customize form fail.": "customize form fail.",
        "smart lock type error.": "smart lock type error.",
        "invalid client id or secret": "invalid client id or secret",
        "invalid account or password": "invalid account or password",
        "invalid access token": "invalid access token",
        "invalid refresh token": "invalid refresh token",
        "no permission to access this project": "no permission to access this project",
        "Stay Alarm Time": "Stay Alarm Time",
        "This function only support sl20 lock.": "This function only support sl20 lock.",
        "Json marshal error.": "Json marshal error.",
        "Json unmarshal error.": "Json unmarshal error.",
        "Illegal request, not added within valid time.": "Illegal request, not added within valid time.",
        "invalid nvr type": "invalid nvr type",
        "project is empty": "project is empty",
        "project type is invalid": "project type is invalid",
        "owner is invalid": "owner is invalid",
        "url is invalid": "url is invalid",
        "password is invalid": "password is invalid",
        "building is invalid": "building is invalid",
        "fail to get data": "fail to get data",
        "invalid allow pm view type": "invalid allow pm view type",
        "Data not exist.": "Data not exist.",
        "cannot find community PrivateKey.": "cannot find community PrivateKey.",
        "cannot find single PrivateKey.": "cannot find single PrivateKey.",
        "The third party not exist.": "The third party not exist.",
        "{0} and indoor monitors/guard phones": "{0} and indoor monitors/guard phones",
        "{0} and indoor monitors/guard phones, with phone as backup": "{0} and indoor monitors/guard phones, with phone as backup",
        "Indoor monitors/guard phones with {0} as backup": "Indoor monitors/guard phones with {0} as backup",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "Indoor monitors/guard phones with {0} as backup, finally the phone",
        "{0} Intercom Feature": "{0} Intercom Feature",
        "Capture on {0}": "Capture on {0}",
        "{0} Intercom Feature is not activated or has expired.": "{0} Intercom Feature is not activated or has expired.",
        "fingerprint code must be equal 1620 characters or empty.": "fingerprint code must be equal 1620 characters or empty.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.",
        "Automatic Locking Time": "Automatic Locking Time",
        "WiFi Keep-Alive": "WiFi Keep-Alive",
        "WiFi Setting": "WiFi Setting",
        "Connecting the network...": "Connecting the network...",
        "Set successfully!": "Set successfully!",
        "The offline code can be used even if the lock is not connected to WiFi.": "The offline code can be used even if the lock is not connected to WiFi.",
        "Enabling this feature will increase the lock\'s power consumption.": "Enabling this feature will increase the lock\'s power consumption.",
        "Each offline code can only be used once.": "Each offline code can only be used once.",
        "Receiver Info": "Receiver Info",
        "log id": "log id",
        "Create HW SN Config Empty SN.": "Create HW SN Config Empty SN.",
        "The SN": "The SN",
        "SN can contain up to 32 characters.": "SN can contain up to 32 characters.",
        "Check HW SN Not Found.": "Check HW SN Not Found.",
        "the end user not found": "the end user not found",
        "Family Call": "Family Call",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "During the upgrade, all lock-related functions will be temporarily unavailable.",
        "8-digit PIN code starting with \"9\" is invalid!": "8-digit PIN code starting with \"9\" is invalid!",
        "Lock name length must be between 1 and 50": "Lock name length must be between 1 and 50",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "The number of admins with landline service cannot exceed the number of those with {0} Intercom.",
        "charge type": "charge type",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "A reader cannot be configured to use both Wiegand and RS485 simultaneously.",
        "parameter error": "parameter error",
        "community name already exist": "community name already exist",
        "personnel app without intercom feature number": "personnel app without intercom feature number",
        "check feature billing charge plan new error": "check feature billing charge plan new error",
        "subscription not found": "subscription not found",
        "System setting record not found.": "System setting record not found.",
        "Smart home not enabled.": "Smart home not enabled.",
        "the apt call type value is invalid.": "the apt call type value is invalid.",
        "the ip call or sip call value is invalid.": "the ip call or sip call value is invalid.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard must be A-F0-9 and less than 16 bits or empty.",
        "owner cannot be empty.": "owner cannot be empty.",
        "creator cannot be empty.": "creator cannot be empty.",
        "the creator type value is invalid": "the creator type value is invalid",
        "the IsCreateByPm value is invalid": "the IsCreateByPm value is invalid",
        "the pinCode already exist": "the pinCode already exist",
        "the rfCard already exist": "the rfCard already exist",
        "license plate is invalid.": "license plate is invalid.",
        "owner info is invalid.": "owner info is invalid.",
        "uhf is invalid.": "uhf is invalid.",
        "time control is invalid.": "time control is invalid.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "You have reached the limit of 5 Vehicle License Plate and are not allowed to add",
        "the plate already exist": "the plate already exist",
        "the uhf already exist": "the uhf already exist",
        "empty community": "empty community",
        "no find license Plate": "no find license Plate",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess mode must be 0, 1, or 2.",
        "Run field is required when mode is 1 or 2.": "Run field is required when mode is 1 or 2.",
        "Serial field is required when mode is 2.": "Serial field is required when mode is 2.",
        "the pin cannot be empty": "the pin cannot be empty",
        "the rfCard cannot be empty": "the rfCard cannot be empty",
        "the IDAccess already exist": "the IDAccess already exist",
        "the resident cannot be empty": "the resident cannot be empty",
        "the fingerprint cannot be empty": "the fingerprint cannot be empty",
        "the face cannot be empty": "the face cannot be empty",
        "not found pin": "not found pin",
        "not found rfCard": "not found rfCard",
        "not found IDAccess": "not found IDAccess",
        "not found fingerprint": "not found fingerprint",
        "not found face": "not found face",
        "face pic is invalid.": "face pic is invalid.",
        "community build and room cannot be empty.": "community build and room cannot be empty.",
        "device info mac cannot be empty.": "device info mac cannot be empty.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.",
        "MAC address cannot be empty.": "MAC address cannot be empty.",
        "MAC address 0C1105000000 is not allowed.": "MAC address 0C1105000000 is not allowed.",
        "MAC address must be 12 hexadecimal characters.": "MAC address must be 12 hexadecimal characters.",
        "Scheduler type value is invalid.": "Scheduler type value is invalid.",
        "parse is fail": "parse is fail",
        "the fingerprint already exist": "the fingerprint already exist",
        "the licensePlate cannot be empty": "the licensePlate cannot be empty",
        "the licensePlate already exist": "the licensePlate already exist",
        "idaccess run must be 10 digit number or end with -K.": "idaccess run must be 10 digit number or end with -K.",
        "idaccess serial must be 9 digit number.": "idaccess serial must be 9 digit number.",
        "relay not in 0-15": "relay not in 0-15",
        "security relay not in 0-3": "security relay not in 0-3",
        "file name is wrong": "file name is wrong",
        "access mode specified": "access mode specified",
        "create community user accessmode failed.": "create community user accessmode failed.",
        "delete community user accessmode failed.": "delete community user accessmode failed.",
        "Cannot delete building because it has associated users.": "Cannot delete building because it has associated users.",
        "Cannot delete building because it has associated Salto devices.": "Cannot delete building because it has associated Salto devices.",
        "community building not found": "community building not found",
        "Invalid Name Display": "Invalid Name Display",
        "The Community does not exist.": "The Community does not exist.",
        "Update CommunityIsInstallerKit Error.": "Update CommunityIsInstallerKit Error.",
        "Dis Not SupportCommunityCalls Error.": "Dis Not SupportCommunityCalls Error.",
        "Community Has Special Device, Not Allowed To Delete.": "Community Has Special Device, Not Allowed To Delete.",
        "The project smart home switch must be disabled": "The project smart home switch must be disabled",
        "There are ITec Locks in project": "There are ITec Locks in project",
        "There are Salto Locks in project": "There are Salto Locks in project",
        "There are Dormakaba Locks in project": "There are Dormakaba Locks in project",
        "It is rent manager project": "It is rent manager project",
        "It is installer account": "It is installer account",
        "contact preference type": "contact preference type",
        "Floor list is required when not all floors.": "Floor list is required when not all floors.",
        "Building floors list is required when all buildings.": "Building floors list is required when all buildings.",
        "Indoor monitor name is required.": "Indoor monitor name is required.",
        "The primary account is not activated.": "The primary account is not activated.",
        "You can\'t create more family member accounts.": "You can\'t create more family member accounts.",
        "community user not found": "community user not found",
        "community is empty": "community is empty",
        "the end user not master user": "the end user not master user",
        "the end user not member user": "the end user not member user",
        "The email already exists and cannot be repeated": "The email already exists and cannot be repeated",
        "The mobile Number already exists": "The mobile Number already exists",
        "The room number format error.": "The room number format error.",
        "community not found": "community not found",
        "resident not found": "resident not found",
        "installer not found": "installer not found",
        "Operation Failed!": "Operation Failed!",
        "You don\'t have operate permission": "You don\'t have operate permission",
        "You cannot select Relay and Door at the same time": "You cannot select Relay and Door at the same time",
        "user don\'t active": "user don\'t active",
        "User has expired": "User has expired",
        "timestamp must be within 3 minutes of current server time": "timestamp must be within 3 minutes of current server time",
        "cannot find single rf Card.": "cannot find single rf Card.",
        "cannot find community rf Card.": "cannot find community rf Card.",
        "smartLock model": "smartLock model",
        "the project does not open smart home": "the project does not open smart home",
        "php web server error": "php web server error",
        "Ins not found.": "Ins not found.",
        "RentManage Unit Not Set.": "RentManage Unit Not Set.",
        "add audit log error": "add audit log error",
        "check building in error": "check building in error",
        "Special devices cannot be deleted": "Special devices cannot be deleted",
        "the email is empty": "the email is empty",
        "the email format is incorrect": "the email format is incorrect",
        "the mobile number is empty": "the mobile number is empty",
        "the mobile number format is incorrect": "the mobile number format is incorrect",
        "Site not found": "Site not found",
        "User not found": "User not found",
        "invalid time format": "invalid time format",
        "ground floor type": "ground floor type",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.",
        "Building ID must be between 1 and 99.": "Building ID must be between 1 and 99.",
        "Community building name": "Community building name",
        "Building ID already exists in this community.": "Building ID already exists in this community.",
        "building ID": "building ID",
        "Community building not found.": "Community building not found.",
        "Cannot delete building because it has associated devices.": "Cannot delete building because it has associated devices.",
        "project is not valid": "project is not valid",
        "Cannot delete building because it has associated salto devices.": "Cannot delete building because it has associated salto devices.",
        "Cannot delete building because it has associated iTec devices.": "Cannot delete building because it has associated iTec devices.",
        "Cannot delete building because it has associated dormakaba devices.": "Cannot delete building because it has associated dormakaba devices.",
        "member limit num": "member limit num",
        "Indoor Monitor No Set Error.": "Indoor Monitor No Set Error.",
        "The room not has indoor": "The room not has indoor",
        "check user in building error": "check user in building error",
        "The name specified is already in use.": "The name specified is already in use.",
        "This timeblock overlaps with an existing one. Please adjust it.": "This timeblock overlaps with an existing one. Please adjust it.",
        "This door status changed. Please try again.": "This door status changed. Please try again.",
        "the lock can\'t bind this community": "the lock can\'t bind this community",
        "The custom quantity limit has been exceeded!": "The custom quantity limit has been exceeded!",
        "This time span overlaps with an existing one. Please adjust it.": "This time span overlaps with an existing one. Please adjust it.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "This one time runs overlap with an existing one time runs effective time. Please adjust it.",
        "Operation Failed. Please try again.": "Operation Failed. Please try again.",
        "The image is not a front view.": "The image is not a front view.",
        "A mask was detected.": "A mask was detected.",
        "The image resolution is too low.": "The image resolution is too low.",
        "No face was detected.": "No face was detected.",
        "The file size is too large.": "The file size is too large.",
        "The face in the image is too large.": "The face in the image is too large.",
        "The face in the image is too small.": "The face in the image is too small.",
        "Multiple faces detected.": "Multiple faces detected.",
        "The face is not clear enough.": "The face is not clear enough.",
        "Face detection failed.": "Face detection failed.",
        "Please enter a value between 1 and 9999": "Please enter a value between 1 and 9999",
        "Please select which input your door sensor is connected to.": "Please select which input your door sensor is connected to.",
        "Add temp key failed, please try it again": "Add temp key failed, please try it again",
        "Dis Not Support Dynamic QRCode Error.": "Dis Not Support Dynamic QRCode Error.",
        "QR code not exist": "QR code not exist",
        "The temp key has expired.": "The temp key has expired.",
        "The device is not in the office": "The device is not in the office",
        "The device is already assigned.": "The device is already assigned.",
        "The device cannot be assigned to any user.": "The device cannot be assigned to any user.",
        "You cannot select an option with fewer users than the current project members.": "You cannot select an option with fewer users than the current project members.",
        "File check failed. Please download the latest template and try again.": "File check failed. Please download the latest template and try again.",
        "Dynamic QR Code not active.": "Dynamic QR Code not active.",
        "Dynamic QR Code not enable.": "Dynamic QR Code not enable.",
        "{0} not found.": "{0} not found.",
        "Tier charge plan": "Tier charge plan",
        "Feature billing charge plan new": "Feature billing charge plan new",
        "Feature billing gradient charge plan": "Feature billing gradient charge plan",
        "The exit time cannot be earlier than the entry time.": "The exit time cannot be earlier than the entry time.",
        "User Name or Password": "User Name or Password",
        "You can only link up to 5 sites.": "You can only link up to 5 sites.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "This license plate is already registered to a resident and cannot be added to the blocklist.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "This license plate is blocklisted and cannot be registered as a vehicle.",
        "Elevator not configured in company access floor.": "Elevator not configured in company access floor.",
        "the device is not in the office": "the device is not in the office",
        "A maximum of 1000 data items can be imported": "A maximum of 1000 data items can be imported",
        "Exit time cannot be later than the current time.": "Exit time cannot be later than the current time.",
        "You can only import a file at a time in the current parking lot.": "You can only import a file at a time in the current parking lot.",
        "The license plate is already in the blocklist.": "The license plate is already in the blocklist.",
        "Building name too long.": "Building name too long.",
        "Unlock failed. Permission denied by user.": "Unlock failed. Permission denied by user.",
        "Please remove the sensor device(s) before disabling this feature.": "Please remove the sensor device(s) before disabling this feature.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "Operation failed! Daily limit of 15 records exceeded for this user.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} public devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} personnel accounts can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "cancel": "Cancel",
        "bluetooth": "Bluetooth",
        "auto": "Auto",
        "Battery Level": "Battery Level",
        "tamperAlarm": "Tamper Alarm",


    }
};
